import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import Style from './seat.module.css';

export default function ItemDisplay({ item, type = 'contingent' }) {
    if (!item) {
        return null;
    }

    const labelKey = type === 'category' ? 'ticket.availability.hover_seat_infos.category' : 'ticket.availability.hover_seat_infos.contingent';

    return (
        <div className={Style['info-block-item']}>
            <div>
                <Trans i18nKey={labelKey} />
            </div>
            <div className={Style['contingent-name']}>
                <div
                    className={Style['contingent-icon']}
                    style={{
                        backgroundColor: item.color
                    }}
                />
                <span className={Style['strong']}>{item.name}</span>
            </div>
        </div>
    );
}

ItemDisplay.propTypes = {
    item: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['contingent', 'category'])
};

ItemDisplay.defaultProps = {
    type: 'contingent'
};
